/**
 * @generated SignedSource<<3bfb3535c7397921f9fa71c51838ae76>>
 * @relayHash f9bb2f232e6821053970e1c2fa1ad8e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 72c3573b568f39d0b4b7beb07a14ca3660006795b5a8b46da4769c8dd3293822

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPageAggQuery$variables = {
  containerId: string;
  isCombinedAggQueryEnabled: boolean;
  isEditPermsEnabled: boolean;
  searchQuery: string;
};
export type ProjectPageAggQuery$data = {
  readonly projects_search?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProjectPageAgg">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ProjectPageAggQuery = {
  response: ProjectPageAggQuery$data;
  variables: ProjectPageAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCombinedAggQueryEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEditPermsEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v4 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchQuery"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "count"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "picture"
},
v11 = [
  (v8/*: any*/),
  (v5/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isUser"
  },
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "AtlassianAccountUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ],
    "type": "AtlassianAccountUser"
  },
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectPageAggQuery",
    "selections": [
      {
        "condition": "isCombinedAggQueryEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects_search",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "isEditPermsEnabled",
                            "variableName": "isEditPermsEnabled"
                          }
                        ],
                        "kind": "FragmentSpread",
                        "name": "ProjectPageAgg"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectPageAggQuery",
    "selections": [
      {
        "condition": "isCombinedAggQueryEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects_search",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "condition": "isEditPermsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareContributorConnection",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareContributorEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareContributor",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareTeamContributor",
                                        "kind": "LinkedField",
                                        "name": "teamContributor",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUserConnection",
                                            "kind": "LinkedField",
                                            "name": "contributingMembers",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              {
                                                "concreteType": "TownsquareUserEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v11/*: any*/)
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "TeamV2",
                                            "kind": "LinkedField",
                                            "name": "team",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "smallAvatarImageUrl"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "profileUrl"
                                              },
                                              {
                                                "concreteType": "TeamMemberConnectionV2",
                                                "kind": "LinkedField",
                                                "name": "members",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TeamMemberEdgeV2",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TeamMemberV2",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "member",
                                                            "plural": false,
                                                            "selections": [
                                                              (v8/*: any*/),
                                                              (v5/*: any*/),
                                                              (v9/*: any*/),
                                                              (v10/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "userContributor",
                                        "plural": false,
                                        "selections": (v11/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v5/*: any*/),
                                      (v10/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canManageOwnership"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddRelatedProjects"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveRelatedProjects"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddLinkedFocusAreas"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveLinkedFocusAreas"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddLinkedGoals"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveLinkedGoals"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddRelatedLink"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditRelatedLink"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveRelatedLink"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddTags"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveTags"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditStartDate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditCustomFields"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canAddLinkedWorkItems"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemoveLinkedWorkItems"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditMetadata"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "72c3573b568f39d0b4b7beb07a14ca3660006795b5a8b46da4769c8dd3293822",
    "metadata": {},
    "name": "ProjectPageAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0f30ffbf2fd106353cfe312cb343f514";

export default node;
